/**
 * @typedef {import('./lib/index.js').Check} Check
 * @typedef {import('./lib/index.js').Test} Test
 * @typedef {import('./lib/index.js').TestFunction} TestFunction
 */

export {is, convert} from './lib/index.js'
